import React from 'react';
import { Box, Typography, Button, Container, keyframes } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import fondo from '../images/fondoOndas.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(58, 107, 126, 0.4);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(58, 107, 126, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(58, 107, 126, 0);
  }
`;

const General = () => {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        minHeight: '80vh', // Occupy most of the view but leave room for footer
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: 4,
        overflow: 'hidden',
        position: 'relative',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      }}
    >
      {/* Glassmorphism Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(5px)',
          zIndex: 1,
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <Box sx={{ animation: `${fadeInUp} 1s ease-out` }}>
          <Typography
            variant="h2"
            component="h1"
            fontWeight="900"
            sx={{
              color: '#001F3F',
              mb: 2,
              letterSpacing: '-1px',
              textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            ¡Detecta tus riesgos y amenazas!
          </Typography>

          <Typography
            variant="h4"
            component="h2"
            sx={{
              color: '#3A6B7E',
              mb: 4,
              fontWeight: 'bold'
            }}
          >
            con el IESS
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: '#555',
              mb: 6,
              maxWidth: '800px',
              mx: 'auto',
              lineHeight: 1.6
            }}
          >
            Ayudamos a encontrar soluciones con intuición y de acuerdo con los objetivos comerciales de su empresa. Brindamos servicios de alta calidad para la gestión integral de la ciberseguridad.
          </Typography>

          <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon />}
            sx={{
              backgroundColor: '#001F3F',
              color: '#fff',
              padding: '15px 40px',
              fontSize: '1.2rem',
              borderRadius: '50px',
              fontWeight: 'bold',
              textTransform: 'none',
              animation: `${pulse} 2s infinite`,
              transition: 'transform 0.2s',
              '&:hover': {
                backgroundColor: '#003366',
                transform: 'scale(1.05)',
              }
            }}
            onClick={() => window.location.href = '/gestionar/nuevo-proceso'} // Or use navigate
          >
            Comenzar Análisis
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default General;
